const $ = window.jQuery || {};

// import "../../gulp/node_modules/jquery-validation/dist/jquery.validate.min.js";

import Main from "./main.js";

$(function () {
  if ($(".lightglobal-forward").length) {
    new Main();
  }
});
